// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Breadcrumbs from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@store/MobiusOverrides/Link/Link";
import usePageType from "@toolkit/Framework/Common/GoogleAnalytics/hooks/utilities/usePageType";
import React from "react";

type Props = {};
const pageTypes = ["HomePage", "CartPage", "OnePageCheckoutPage"];
const OnePageCheckoutBreadcrumbs: React.FC<Props> = () => {
    const isConfirmationPAge = usePageType() === "OnePageCheckoutConfirmationPage";
    const pageTypesToUse = isConfirmationPAge ? [...pageTypes, "OnePageCheckoutConfirmationPage"] : pageTypes;
    const links: LinkProps[] = useAppSelector(state => {
        return pageTypesToUse.map<LinkProps>(pageType => {
            const pageLink = getPageLinkByPageType(state, pageType);
            return {
                children: pageLink?.title,
                href: pageLink?.url,
            };
        });
    });
    return <Breadcrumbs links={links} />;
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutBreadcrumbs,
    definition: {
        group: "One Page Checkout",
        icon: "chevrons-right",
        allowedContexts: ["OnePageCheckoutConfirmationPage", "OnePageCheckoutPage"],
    },
};

export default widgetModule;
